import { GenericUploadFileFormat, getFileExtension } from "@ryde/shared";

// Maps a file extension to the parser format that handles it. This is the
// single place to extend when a new upload format is added: register the
// extension here and add a matching parser in genericUploadParseFile.
const FILE_EXTENSION_FORMAT_MAP: Record<string, GenericUploadFileFormat> = {
  csv: GenericUploadFileFormat.Csv,
  xlsx: GenericUploadFileFormat.Excel,
  xls: GenericUploadFileFormat.Excel,
};

export const getGenericUploadFileFormat = (
  file: File,
): GenericUploadFileFormat | undefined => {
  return FILE_EXTENSION_FORMAT_MAP[getFileExtension(file.name)];
};

export const isSupportedGenericUploadFile = (file: File): boolean => {
  return getGenericUploadFileFormat(file) !== undefined;
};
